import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CrudService } from '@app/api/api-services/crud.service';
import { RatingApiModel, RatingDisplaySettingsApiModel } from '@app/api/api-models';

@Injectable()
export class RatingsService extends CrudService<RatingApiModel, number> {
  public readonly apiUrl = 'ratings';

  public getPrint(): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/print`, { responseType: 'blob' });
  }

  /** Read-only scale for any role (the CRUD list is admin-only); used to name a score or an average. */
  public getScale(): Observable<RatingApiModel[]> {
    return this.http.get<RatingApiModel[]>(`${this.apiUrl}/scale`);
  }

  public getDisplaySettings(): Observable<RatingDisplaySettingsApiModel> {
    return this.http.get<RatingDisplaySettingsApiModel>(`${this.apiUrl}/display-settings`);
  }

  public updateDisplaySettings(settings: RatingDisplaySettingsApiModel): Observable<RatingDisplaySettingsApiModel> {
    return this.http.put<RatingDisplaySettingsApiModel>(`${this.apiUrl}/display-settings`, settings);
  }
}
